import React, { useEffect, useState } from 'react';
import RightModal from '../../../../../components/shared/RightModal';
import StepModel from '../../../../models/StepModel';
import { getStatusMeta } from './stepStatusHelpers';
import { formatSummaryDateWithSeconds } from '../../../../../util/dateUtils';
import { useTranslation } from 'react-i18next';
import ModalHeader from '../../../../../components/Automations/ChatbotAI/ModalHeader';

const StepDetail = ({ stepId, onClose }) => {
  const { t } = useTranslation('ChatbotIA');
  const [step, setStep] = useState(null);

  useEffect(() => {
    if (!stepId) return;
    StepModel.retrieve(stepId)
      .then((response) => {
        const payload = response?.data || response;
        setStep(payload);
      })
      .catch((error) => {
        console.error('Error fetching step details', error);
      });
  }, [stepId]);

  if (!stepId) return null;

  const handleClose = () => {
    if (onClose) onClose();
  };

  const statusMeta = getStatusMeta(step?.step_status);
  const statusLabel = statusMeta?.label;
  const statusActive = statusMeta?.active;

  return (
    <RightModal>
      <div className="mercately-modal">
        <ModalHeader
          title={t('memory.step_detail.title')}
          toggleModal={handleClose}
          centeredTitle={false}
        />

        <div className="px-24 py-32 wrap-text" style={{ color: '#23292E' }}>
          <span className="font-600 fz-14 pb-8">{step?.intention_name}</span>
          <p className="fz-13 pb-15 m-0">{step?.step_description}</p>

          <div className="pb-2">
            <span className="fs-12 text-primary">
              {t('memory.step_detail.date')}
            </span>
            <span className="fs-13">
              {formatSummaryDateWithSeconds(step?.created_at)}
            </span>
          </div>

          <div>
            <span className="fs-12 text-primary">
              {t('memory.step_detail.status')}
            </span>

            <span
              className="align-middle font-500 fs-12 px-8 py-2"
              style={{
                borderRadius: 5,
                background: statusActive
                  ? 'var(--Green-50, #EFFAF3)'
                  : 'var(--Yellow-50, #FFFCEB)',
                color: statusActive
                  ? 'var(--Green-500, #2E9B62)'
                  : 'var(--Yellow-700, #B65A07)',
              }}
            >
              {statusLabel}
            </span>
          </div>
        </div>
      </div>
    </RightModal>
  );
};

export default StepDetail;
